import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import Head from "next/head";
import { ViewProductKlaviyo } from "helpers/klaviyo";
import styles from "./styles-accessories";
import ImageGallery from "./ImageGallery";
import ImagesGalleryMobile from "./ImagesGalleryMobile";
import ProductDescriptions from "./ProductDescriptions/index-accessories";
import ProductPerformance from "./ProductPerformance";
import ProductWarranty from "./ProductWarranty";
import ProductSpecification from "./ProductSpecification";
import ProductFeatures from "./ProductFeatures";
import ImageViewer from "./ImageViewer";
import BreadcrumbMenu from "./BreadcrumbMenu";
import EssentialProducts from "./EssentialProducts";
import ProductAddToCart from "./ProductDescriptions/ProductAddToCart";
import ProductAddCartMobile from "./ProductDescriptions/ProductAddCartMobile";

const ProductAccessories = ({ data }) => {
  const [showModal, setShowModal] = useState(false);
  const [imageIndex, setImageIndex] = useState(0);
  const { product } = data;
  const [addToCart, setAddToCart] = useState([data?.product]);
  console.log('data :::::', data)

  const productTitle = product.title;
  const productId = product.id;
  const productHandle = product.handle;
  const productPrice = product.variants.edges[0].node.price;
  const productSKU = product.variants.edges[0].node.sku;
  const productImage = product.images?.edges[0]?.node?.originalSrc;
  const imagesGallery = product.images.edges;
  const productVariant = product.variants.edges[0].node;
  const productTags = product.tags;
  const productAvailable =
    product?.variants?.edges[0]?.node?.quantityAvailable > 0;
  const productCompareAtPrice = product.variants.edges[0].node.compareAtPrice;
  const productDescription = (
    <div
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: data.product.descriptionHtml }}
    />
  );

  const sameDayShipping = productTags.filter((item) =>
    item.startsWith("shipping:")
  );
  const [finalProductPrice, setFinalProductPrice] = useState(
    data?.product?.variants?.edges[0]?.node?.price
  );
  const [finalComparedProductPrice, setFinalComparedProductPrice] = useState(
    data?.product?.variants.edges[0].node.compareAtPrice
  );
  return (
    <>
      {global?.window?._learnq
        ? ViewProductKlaviyo(
            productTitle,
            productId,
            productImage,
            productPrice,
            productCompareAtPrice,
            productHandle,
            productSKU
          )
        : ''}
      <div className="product_section wrapper">
        <BreadcrumbMenu
          productHandle={productHandle}
          productTitle={productTitle}
          productTags={productTags}
        />
        {showModal ? (
          <ImageViewer
            imagesGallery={imagesGallery}
            handleModalClose={setShowModal}
            imageIndex={imageIndex}
            handleImageIndex={setImageIndex}
          />
        ) : null}

        <div className="product_information">
          <div className="product_images_section">
            <ImageGallery
              productImage={productImage}
              imagesGallery={imagesGallery}
              productTitle={productTitle}
              showModal={showModal}
              handleModalOpen={setShowModal}
              handleImageIndex={setImageIndex}
            />
          </div>

          <div className="images_gallery_mobile">
            <ImagesGalleryMobile
              imagesGallery={imagesGallery}
              showModal={showModal}
              handleModalOpen={setShowModal}
              handleImageIndex={setImageIndex}
            />
          </div>

          <div className="product_contents">
            <ProductDescriptions
              productTitle={productTitle}
              productPrice={productPrice}
              productVariant={productVariant}
              productDescription={productDescription}
              productCompareAtPrice={productCompareAtPrice}
              productTags={productTags}
              productImage={productImage}
              productHandle={productHandle}
              productSKU={productSKU}
              productAvailable={productAvailable}
              productId={productId}
            />
            <ProductPerformance productTags={productTags} />
            <ProductFeatures productTags={productTags} />
            <ProductWarranty productTags={productTags} />
            <ProductSpecification productTags={productTags} />
          </div>
        </div>
        <div className="essential_products">
          <EssentialProducts productTags={productTags} />
        </div>
        <div className="product_footer">
          <div className="wrapper">
            <div className="product_add2cart cart__desktop">
              <ProductAddToCart
                sameDayShipping={sameDayShipping}
                products={addToCart}
                productTitle={productTitle}
                productPrice={finalProductPrice.amount}
                productVariant={productVariant}
                productCompareAtPrice={finalComparedProductPrice.amount}
                productAvailable={productAvailable}
                productId={productId}
              />
            </div>
            <div className="product_add2cart cart__mobile">
              <ProductAddCartMobile
                sameDayShipping={sameDayShipping}
                products={addToCart}
                productTitle={productTitle}
                productPrice={finalProductPrice.amount}
                productVariant={productVariant}
                productCompareAtPrice={finalComparedProductPrice.amount}
                productAvailable={productAvailable}
                productId={productId}
              />
            </div>
          </div>
        </div>
      </div>

      <style jsx>{styles}</style>
    </>
  );
};

ProductAccessories.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  data: PropTypes.object.isRequired,
};

export default ProductAccessories;